/**
 * gsap-scrolling
 *
 */

import $ from "jquery";


export default function gsapScolling() {

    // When gsapScolling exists
    if (gsapScolling) {
        let $obj = $('.scroll-content');

        gsap.registerPlugin(ScrollTrigger);


        var productsMobileAnim = gsap.timeline({
            id: "Products Mobile"
        });

        var productsAnim = gsap.timeline({
            id: "products"
        });

        var endOfPx = 100;


        let wWidth = window.innerWidth ? window.innerWidth : $(window).width();

        if (wWidth > 767) {
            endOfPx = 200;
        }


        // let tl = gsap.timeline()
        //     .to('.box', {
        //         // duration:1,
        //         rotate: -10,
        //         scale: .7,
        //         ease: 'none',
        //     }, '+=5');


        // ScrollTrigger.create({
        //     trigger: '.box',
        //     animation: tl,
        //     pin: true,
        //     pinSpacing: false,
        //     start: '-50% top',
        //     end: () => '+=' + (document.querySelector('.scroll-content-container').offsetHeight - endOfPx),
        //     scrub: 1, // I like the 1 sec delay, set to true for exact anime on scroll
        //     // markers: true,
        // })

    }


    ScrollTrigger.matchMedia({
        "(max-width: 767px)": function maxWidth767px() {
            var classicmixMobileTl = gsap.timeline({
                id: "classicmixMobile"
            });

            classicmixMobileTl.set("#classicmix", {
                opacity: 1
            }).fromTo("#classicmix", {
                scale: .5,
                rotate: -10,
                yPercent: -50,
                xPercent: -200,
            }, {
                duration: 3,
                scale: 1,
                rotate: 20,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsMobileAnim.add(classicmixMobileTl, "-=3.5");



            var milchMobileTl = gsap.timeline({
                id: "milchMobile"
            });

            milchMobileTl.set("#milch", {
                opacity: 1
            }).fromTo("#milch", {
                scale: .5,
                rotate: 30,
                xPercent: 200,
                yPercent: -50,
            }, {
                duration: 3,
                scale: 1,
                rotate: 0,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsMobileAnim.add(milchMobileTl, "-=3.5");


            var alpenvollmilchschokoladeMobileTl = gsap.timeline({
                id: "alpenvollmilchschokoladeMobile"
            });

            alpenvollmilchschokoladeMobileTl.set("#alpenvollmilchschokolade", {
                opacity: 1
            }).fromTo("#alpenvollmilchschokolade", {
                scale: .5,
                rotate: 50,
                yPercent: -10,
                xPercent: 200,
            }, {
                duration: 3,
                scale: 1,
                rotate: 20,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsMobileAnim.add(alpenvollmilchschokoladeMobileTl, "-=3.5");


            var prinzessbohnenMobileTl = gsap.timeline({
                id: "prinzessbohnenMobile"
            });

            prinzessbohnenMobileTl.set("#prinzessbohnen", {
                opacity: 1
            }).fromTo("#prinzessbohnen", {
                scale: .5,
                rotate: 10,
                yPercent: 30,
                xPercent: -200,
            }, {
                duration: 3,
                scale: 1,
                rotate: -10,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsMobileAnim.add(prinzessbohnenMobileTl, "-=4.5");

            var heuteflipsMobileTl = gsap.timeline({
                id: "heuteflipsMobile"
            });

            heuteflipsMobileTl.set("#heuteflips", {
                opacity: 1
            }).fromTo("#heuteflips", {
                scale: .5,
                rotate: -10,
                yPercent: -50,
                xPercent: -350,
            }, {
                duration: 2,
                scale: 1,
                rotate: 9,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsMobileAnim.add(heuteflipsMobileTl, "-=3.5");

            ScrollTrigger.create({
                trigger: "#product-range-animation-container",
                start: "-=70%",
                end: "center-=40%",
                // markers: {startColor: "blue", endColor: "red"},
                scrub: .75,
                animation: productsMobileAnim
            });
        },
        "(min-width: 768px)": function minWidth768pxAndMaxWidth1199px() {
            // classicmix
            var classicmixTl = gsap.timeline({
                id: "classicmix"
            });

            classicmixTl.set("#classicmix", {
                opacity: 1
            }).fromTo("#classicmix", {
                scale: 1,
                rotate: 0,
                xPercent: -30,
                yPercent: -30,
            }, {
                duration: 3,
                scale: 1,
                rotate: 20,
                xPercent: 10,
                yPercent: 0,
                ease: "power2.out",
            });
            productsAnim.add(classicmixTl, 0);


            var prinzessbohnenTl = gsap.timeline({
                id: "prinzessbohnen"
            });

            prinzessbohnenTl.set("#prinzessbohnen", {
                opacity: 1
            }).fromTo("#prinzessbohnen", {
                scale: 1,
                rotate: 0,
                xPercent: -30,
                yPercent: -20,
            }, {
                duration: 3,
                scale: 1,
                rotate: -10,
                xPercent: 10,
                yPercent: 50,
                ease: "power2.out",
            });
            productsAnim.add(prinzessbohnenTl, 0);


            var cremefraicheTl = gsap.timeline({
                id: "cremefraiche"
            });

            cremefraicheTl.set("#cremefraiche", {
                opacity: 1
            }).fromTo("#cremefraiche", {
                scale: 1,
                rotate: 0,
                xPercent: -100,
                yPercent: 80,
            }, {
                duration: 3,
                scale: 1,
                rotate: 10,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsAnim.add(cremefraicheTl, 0);


            var textmarkerTl = gsap.timeline({
                id: "textmarker"
            });

            textmarkerTl.set("#textmarker", {
                opacity: 1
            }).fromTo("#textmarker", {
                scale: 1,
                rotate: 0,
                xPercent: -100,
                yPercent: 80,
            }, {
                duration: 3,
                scale: 1,
                rotate: -10,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsAnim.add(textmarkerTl, 0);


            var alpenvollmilchschokoladeTl = gsap.timeline({
                id: "alpenvollmilchschokolade"
            });

            alpenvollmilchschokoladeTl.set("#alpenvollmilchschokolade", {
                opacity: 1
            }).fromTo("#alpenvollmilchschokolade", {
                scale: 1,
                rotate: 0,
                xPercent: 100,
                yPercent: 80,
            }, {
                duration: 3,
                scale: 1,
                rotate: -10,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsAnim.add(alpenvollmilchschokoladeTl, 0);


            var steinofenpizzaTl = gsap.timeline({
                id: "steinofenpizza"
            });

            steinofenpizzaTl.set("#steinofenpizza", {
                opacity: 1
            }).fromTo("#steinofenpizza", {
                scale: 1,
                rotate: 0,
                xPercent: 100,
                yPercent: 80,
            }, {
                duration: 3,
                scale: 1,
                rotate: 10,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsAnim.add(steinofenpizzaTl, 0);

            var milchTl = gsap.timeline({
                id: "milch"
            });

            milchTl.set("#milch", {
                opacity: 1
            }).fromTo("#milch", {
                scale: 1,
                rotate: 0,
                xPercent: 50,
                yPercent: -20,
            }, {
                duration: 3,
                scale: 1,
                rotate: 10,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsAnim.add(milchTl, 0);


            var becherTl = gsap.timeline({
                id: "becher"
            });

            becherTl.set("#becher", {
                opacity: 1
            }).fromTo("#becher", {
                scale: 1,
                rotate: 0,
                xPercent: 50,
                yPercent: -40,
            }, {
                duration: 3,
                scale: 1,
                rotate: 10,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsAnim.add(becherTl, 0);


            var basmatireisTl = gsap.timeline({
                id: "basmatireis"
            });

            basmatireisTl.set("#basmatireis", {
                opacity: 1
            }).fromTo("#basmatireis", {
                scale: 1,
                rotate: 0,
                xPercent: -20,
                yPercent: -20,
            }, {
                duration: 3,
                scale: 1,
                rotate: -10,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsAnim.add(basmatireisTl, 0);

            var heuteflipsTl = gsap.timeline({
                id: "heuteflips"
            });

            heuteflipsTl.set("#heuteflips", {
                opacity: 1
            }).fromTo("#heuteflips", {
                scale: 1,
                rotate: 0,
                xPercent: -20,
                yPercent: -20,
            }, {
                duration: 3,
                scale: 1,
                rotate: -5,
                xPercent: 0,
                yPercent: 0,
                ease: "power2.out",
            });
            productsAnim.add(heuteflipsTl, 0);

            ScrollTrigger.create({
                trigger: "#product-range-animation-container",
                start: '-45% 25%',
                end: () => '+=' + (document.querySelector('#product-range-animation-container').offsetHeight - 350),
                // markers: {startColor: "pimk", endColor: "yellow"},
                scrub: .3,
                animation: productsAnim
            });
        }
    });


    // function animateSVG($obj) {

    //     if (!$obj.length) return;


    //     $.each($obj, function() {
    //         let $this = $(this);

    //         let animationName = $this.attr('data-name');
    //         let animationDataPath = $this.attr('data-animation-path');
    //         let animationContainer = $this[0];
    //         // let animationLoop = $this.attr('data-loop');


    //         let params = {
    //             container: animationContainer,
    //             name: animationName,
    //             // autoplay: true,
    //             loop: true,
    //             path: animationDataPath,
    //             renderer: 'svg'
    //         };

    //         lottie.setLocationHref(window.location.href.split('#')[0]);
    //         lottie.setQuality('low');

    //         let anim = lottie.loadAnimation(params);

    //         // if (animationLoop !== '') {
    //         //   anim.playSegments(JSON.parse(animationLoop), true);
    //         // }
    //     });

    // }

    // function destroySVGAnimation($obj) {
    //     let animationName = $obj.attr('data-name');
    //     lottie.destroy(animationName);
    // }




    // animateSVG($(document).find('.animated-illu-loading'));


    // gsap.utils.toArray('.scroll-content').forEach((panel, i) => {
    //     ScrollTrigger.create({
    //         trigger: panel,
    //         start: "150% 100%",
    //         pin: true,
    //         pinSpacing: false,
    //         // markers: true,
    //         end: "top bottom",
    //         // snap: 7,
    //         onEnter: function() {

    //             if ($(panel).hasClass('scroll-content-01')) {
    //                 // $('.flips').removeClass('m-fadeIn');
    //                 document.querySelector('.a').classList.add('m-fadeOut');

    //                 // document.querySelector('.b').classList.add('animate', 'm-fadeIn');
    //                 $('.b').addClass('animate m-fadeIn');
    //             }

    //             if ($(panel).hasClass('scroll-content-02')) {
    //                 document.querySelector('.b').classList.remove('m-fadeIn');
    //                 // document.querySelector('.c').classList.add('animate', 'm-fadeIn');

    //                 $('.c').addClass('animate m-fadeIn');
    //             }

    //             if ($(panel).hasClass('scroll-content-03')) {
    //                 document.querySelector('.c').classList.remove('m-fadeIn');
    //                 // document.querySelector('.d').classList.add('animate', 'm-fadeIn');
    //                 $('.d').addClass('animate m-fadeIn');
    //             }

    //             if ($(panel).hasClass('scroll-content-04')) {
    //                 document.querySelector('.d').classList.remove('m-fadeIn');
    //                 // document.querySelector('.e').classList.add('animate', 'm-fadeIn');
    //                 $('.e').addClass('animate m-fadeIn');
    //                 document.querySelector('.year-02').classList.add('scale-in');
    //             }

    //             if ($(panel).hasClass('scroll-content-06')) {
    //                 document.querySelector('.year-02').classList.remove('scale-in');
    //             }

    //         },
    //         onEnterBack: function() {
    //             if ($(panel).hasClass('scroll-content-01')) {
    //                 document.querySelector('.a').classList.remove('m-fadeOut');
    //                 document.querySelector('.b').classList.remove('m-fadeIn');
    //             }

    //             if ($(panel).hasClass('scroll-content-02')) {
    //                 document.querySelector('.c').classList.remove('m-fadeIn');
    //                 document.querySelector('.b').classList.add('m-fadeIn');
    //             }

    //             if ($(panel).hasClass('scroll-content-03')) {
    //                 document.querySelector('.d').classList.remove('m-fadeIn');
    //                 document.querySelector('.c').classList.add('m-fadeIn');
    //             }

    //             if ($(panel).hasClass('scroll-content-04')) {
    //                 document.querySelector('.e').classList.remove('m-fadeIn');
    //                 document.querySelector('.d').classList.add('m-fadeIn');
    //                 document.querySelector('.year-02').classList.remove('scale-in');
    //             }

    //             if ($(panel).hasClass('scroll-content-05')) {
    //                 document.querySelector('.year-02').classList.add('scale-in');
    //             }

    //             if ($(panel).hasClass('scroll-content-06')) {
    //                 document.querySelector('.year-02').classList.add('scale-in');
    //             }
    //         },
    //         onLeave: function() {
    //             if ($(panel).hasClass('scroll-content-05')) {
    //                 document.querySelector('.year-02').classList.remove('scale-in');
    //             }
    //         }
    //     });
    // });


    //get all vids
    let video = document.querySelectorAll('.video-header')

    //add source to video tag
    function addSourceToVideo(element, src) {
        let source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        // console.log(src);
        element.appendChild(source);

    }

    //determine screen size and select mobile or desktop vid
    function whichSizeVideo(element, src) {
        let windowWidth = window.innerWidth ? window.innerWidth : $(window).width();
        $('.video-header source').remove();

        if (windowWidth > 767) {
            addSourceToVideo(element, src.dataset.desktopVid);
        } else {
            addSourceToVideo(element, src.dataset.mobileVid);
        }
        element.load();
    }

    //init only if page has videos
    function videoSize() {
        if (video !== undefined) {
            video.forEach(function(element, index) {
                whichSizeVideo(
                    element, //element
                    element //src locations
                );
            });
        }
    }
    videoSize();

}
